
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/gold-loans/safety-of-glfh",
      function () {
        return require("private-next-pages/help/gold-loans/safety-of-glfh.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/gold-loans/safety-of-glfh"])
      });
    }
  